import horoscope from "@/assets/img/today/nav/horoscope.webp"
import reports from "@/assets/img/today/nav/reports.webp"
import tarot from "@/assets/img/today/nav/tarot.webp"
import runes from "@/assets/img/today/nav/runes.webp"
import moon from "@/assets/img/today/nav/moon.webp"
import numerology from "@/assets/img/today/nav/numerology.webp"
import biorhythm from "@/assets/img/today/nav/biorhythm.webp"

export const TODAY_CATEGORIES = {
  HOROSCOPE: "horoscope",
  REPORTS: "reports",
  TAROT: "tarot",
  RUNES: "runes",
  MOON: "moon",
  NUMEROLOGY: "numerology",
  BIORHYTHM: "biorhythm",
} as const

export type TodayCategory = (typeof TODAY_CATEGORIES)[keyof typeof TODAY_CATEGORIES]

export interface TodayCategoryItem {
  id: TodayCategory
  name: string
  image: string
}

export const todayCategories: TodayCategoryItem[] = [
  { id: TODAY_CATEGORIES.HOROSCOPE, name: "Horoscope", image: horoscope },
  { id: TODAY_CATEGORIES.REPORTS, name: "Reports", image: reports },
  { id: TODAY_CATEGORIES.TAROT, name: "Tarot", image: tarot },
  { id: TODAY_CATEGORIES.RUNES, name: "Runes", image: runes },
  { id: TODAY_CATEGORIES.MOON, name: "Moon phase", image: moon },
  { id: TODAY_CATEGORIES.NUMEROLOGY, name: "Numerology", image: numerology },
  { id: TODAY_CATEGORIES.BIORHYTHM, name: "Biorhythm", image: biorhythm },
]
